
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { DFIInspectionReportVM, GenericIdName, InspectorDto } from '../setup-implement/setup-implement.model';
import {  Tuple } from '../setup-equipment/setup-equipment.model';
//import { HttpParams, HttpClient } from '@angular/common/http';
import { DigitalFormDataVM, DigitalFormQuestionsVM, UpdateQuestion, SectionQuestionsVM, FormHeaderVM, QustionHistoryVM, GETDashboardComponentHistroyInspectionVM, formUploadDate, DigitalFormSearchVM } from '../favourite-dialog/favourite-dialog-modal';
import { catchError, share } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { throwError } from 'rxjs';

@Injectable()
export class DigitalFormService {
  constructor(private _http: HttpClient) { }

  private readonly API_BASE = 'api/DigitalFormIdentity/';
  private readonly GET_FORM_UPLOAD_INFO = this.API_BASE + 'GetUploadFormDetails';
  private readonly GET_FORM_UPLOAD_INFO_BYDATE = this.API_BASE + 'GetUploadFormDetailsByDate';
  private readonly UPDATE_FORM_QUESTION_CHANGES = this.API_BASE + 'UpadateQuestionsForParentCategory';
  private readonly CREATE_COPY_FORM = this.API_BASE + 'CopyNewDigitalForm';
  private readonly UPADATE_FORM_STATUS = this.API_BASE + 'UpdateFormStatus';
  private readonly GET_SECTION_QUESTIONS = this.API_BASE + 'GetSectionQuestionInfo';
  private readonly GetFormHeaderInfo=this.API_BASE +'GetDigitalFormHeaderDetails';
  private readonly UPDATE_FORM_QUESTION_FLAG = this.API_BASE + 'UpdateQuestionFlagInfo';
  private readonly UPADATE_FORM_OVERALL_COMMENT = this.API_BASE + 'UpdateFormComment';
  private readonly GET_QUESTION_HISTORY = this.API_BASE + 'GetQuestionHistoryForNormalQuestion';
  private readonly GET_STRUCTURAL_QUESTION_HISTORY = this.API_BASE + 'GetQuestionHistoryForStructuralQuestion';
  private readonly UPDATE_INSPECTION_SMU = this.API_BASE + 'UpdateFormUploadSMU';
  private readonly UPDATE_WORK_ORDER = this.API_BASE + 'UpdateWorkOrder';
  private readonly GET_DASHBOARD_COMPONENT_HISTROY='api/GETDashboard/GetComponentHistroyForGETDashboard';
  private readonly GET_DFI_EQ_COMPONENT_HISTROY='api/GETDashboard/GetDFIComponentLinkQuestionsForEquipment';

  // public GetDigitalFormHeaderFields(formId: number): Observable<FormHeaderVM[]> {
  //   let params = new HttpParams();
  //   params.set('formId', formId.toString());
  //   return this._http.get<FormHeaderVM[]>(this.GetFormHeaderInfo, { params }).pipe(
  //     share(),catchError(this.handleError));
   
  // }
  public GetDigitalFormHeaderFields(formId: number): Observable<FormHeaderVM[]> {
    let params = new HttpParams().set('formId', formId.toString());
    
    return this._http.get<FormHeaderVM[]>(this.GetFormHeaderInfo, { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }
  
  GetDigitalFormUploadQuestionDetailsForSections(formId: number, uploadId: number, sectionId: number): Observable<SectionQuestionsVM> {
    let params = new HttpParams()
      .set('formId', formId.toString())
      .set('uploadId', uploadId.toString())
      .set('sectionId', sectionId.toString());

    return this._http.get<SectionQuestionsVM>(this.GET_SECTION_QUESTIONS, { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }

  public UpdateUploadInspectionSMU(SMU: number, uploadId:number): Observable<boolean> {
    let params = new HttpParams()
    .set('SMU', SMU.toString())
    .set('uploadId', uploadId.toString());

    return this._http.get<any>(this.UPDATE_INSPECTION_SMU, { params }).pipe(
      share(),catchError(this.handleError));
  }

//   public UpdateWorkOrder(WO: string, uploadId:number): Observable<boolean> {
//     let params: URLSearchParams = new URLSearchParams();
//     params.set('WO', WO);
//     params.set('uploadId', uploadId.toString());

//   //   return this._http.get(this.UPDATE_WORK_ORDER, { search: params }).share().map(
//   //       (response: Response) => <boolean>response.json()).catch(this.handleError);
//   // }
//   return this._http.get<boolean>(this.UPDATE_WORK_ORDER, { params }).pipe(
//     share(),catchError(this.handleError));
// }
public UpdateWorkOrder(WO: string, uploadId: number): Observable<boolean> {
  let params = new HttpParams()
      .set('WO', WO)
      .set('uploadId', uploadId.toString());

  return this._http.get<boolean>(this.UPDATE_WORK_ORDER, { params }).pipe(
      share(),
      catchError(this.handleError)
  );
}


//   public UpdateFormUploadDate(data: formUploadDate): Observable<boolean> {
//     let params: URLSearchParams = new URLSearchParams();
//     params.set('uploadId', data.uploadId.toString());
//     params.set('startDate', data.startDate.toDateString());

//     return this._http.get("api/DigitalFormIdentity/UpdateFormUploadDate", { search: params }).share().map(
//         (response: Response) => <boolean>response.json()).catch(this.handleError);
// }


public UpdateFormUploadDate(params: formUploadDate): Observable<boolean> {
  return this._http.post<any>("api/DigitalFormIdentity/UpdateFormUploadDate", params).pipe(
    share(),catchError(this.handleError));
}


  public GetDigitalFormUploadDetails(formId: number, uploadId:number): Observable<DigitalFormDataVM> {
    let params = new HttpParams()
    .set('formId', formId.toString())
    .set('uploadId', uploadId.toString());

    return this._http.get<DigitalFormDataVM>(this.GET_FORM_UPLOAD_INFO, { params }).pipe(
      share(),catchError(this.handleError));
  }

  public GetDigitalFormUploadDetailsByDate(params: DigitalFormSearchVM): Observable<DigitalFormDataVM> {
    return this._http.post<DigitalFormDataVM>(this.GET_FORM_UPLOAD_INFO_BYDATE, params).pipe(
      share(),
      catchError(this.handleError)
    );
  }

  public UpdateQuestionsForSpecifcCategory(params: UpdateQuestion): Observable<boolean> {
    return this._http.post<any>(this.UPDATE_FORM_QUESTION_CHANGES, params).pipe(
      share(),catchError(this.handleError));
  }

  public CreateDigitalFormCopy(oldFormId: number, NewFormName:string): Observable<Tuple> {
    let params = new HttpParams()
    .set('oldFormId', oldFormId.toString())
    .set('NewFormName', NewFormName);

    return this._http.get<any>(this.CREATE_COPY_FORM, { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }


  
  public UpdateUploadFormStatus(UploadId: number, StatusId:number, QuestionsOverAllStatus: number): Observable<boolean> {
    let params = new HttpParams()
    .set('UploadId', UploadId.toString())
    .set('StatusId', StatusId.toString())
    .set('QuestionsOverAllStatus', QuestionsOverAllStatus.toString());
    return this._http.get<any>(this.UPADATE_FORM_STATUS, { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }


  public UpdateQuestionsFlag(params: DigitalFormQuestionsVM): Observable<boolean> {
    return this._http.post<any>(this.UPDATE_FORM_QUESTION_FLAG, params).pipe(
      share(),
      catchError(this.handleError)
    );
  }


  public UpdateUploadOverallComment(UploadId: number, comment:string): Observable<boolean> {
    let params = new HttpParams()
    
    .set('UploadId', UploadId.toString())
    .set('comment', comment);

    return this._http.get<any>(this.UPADATE_FORM_OVERALL_COMMENT, { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }

  public GETSelectedQuestionHistory(QuestionId: number, EquipmentId:number,UploadId:number): Observable<QustionHistoryVM> {
    console.log(QuestionId, EquipmentId,UploadId)
    let params = new HttpParams()
    .set('QuestionId', QuestionId.toString())
    .set('EquipmentId', EquipmentId.toString())
    .set('UploadId', UploadId.toString())


    return this._http.get<any>(this.GET_QUESTION_HISTORY, { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }
  
  public GETSelectedStructuaralQuestionHistory(QuestionId: number, EquipmentId:number,UploadId:number): Observable<QustionHistoryVM> {
    console.log(QuestionId, EquipmentId,UploadId)
    let params = new HttpParams()
    .set('QuestionId', QuestionId.toString())
    .set('EquipmentId', EquipmentId.toString())
    .set('UploadId', UploadId.toString());


    return this._http.get<any>(this.GET_STRUCTURAL_QUESTION_HISTORY, { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }

  public GetComponentHistroyForGETDashboard(componentId: number): Observable<GETDashboardComponentHistroyInspectionVM[]> {
    let params = new HttpParams()
    .set('componentId', componentId.toString());
    return this._http.get<GETDashboardComponentHistroyInspectionVM[]>(this.GET_DASHBOARD_COMPONENT_HISTROY, { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }

  public GetDFIComponentHistroyForEquipment(EquipmentId: number): Observable<GETDashboardComponentHistroyInspectionVM[]> {
    let params = new HttpParams()
    .set('EquipmentId', EquipmentId.toString());
    return this._http.get<GETDashboardComponentHistroyInspectionVM[]>(this.GET_DFI_EQ_COMPONENT_HISTROY, { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }
  
  public UpdateDFIInspection(InspectionId: number): Observable<Tuple> {
    let params = new HttpParams().
    set('InspectionId', InspectionId.toString());

    return this._http.get<Tuple>('api/GETNewInspection/UpdateGETDFI_Inspections_DFIInspection', { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }

  GetDFIInspectionReportSections(FormUploadID: number): Observable<DFIInspectionReportVM[]> {
    let params = new HttpParams().set('FormUploadID', FormUploadID.toString());
      
    return this._http.get<DFIInspectionReportVM[]>('api/DigitalFormIdentity/GetDFIInspectionReportSections', { params })
      .pipe(
        share(),
        catchError(this.handleError)
      );
    }
  public DFIReportInspectionIncludeBody(FormUploadID: number, CategoryID:number): Observable<boolean> {
   
    let params = new HttpParams()
    .set('FormUploadID', FormUploadID.toString())
    .set('CategoryID', CategoryID.toString());  
    return this._http.get<any>('api/DigitalFormIdentity/DFIReportInspectionIncludeBody', { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }
  public DFIReportInspectionIncludeDataTable(FormUploadID: number, CategoryID:number): Observable<boolean> {
   
    let params = new HttpParams()
    .set('FormUploadID', FormUploadID.toString())
    .set('CategoryID', CategoryID.toString());  
    return this._http.get<any>('api/DigitalFormIdentity/DFIReportInspectionIncludeDataTable', { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }

  public DFIReportUpdateCategoryName(FormUploadID: number, CategoryID:number, categoryName:string): Observable<boolean> {
   
    let params = new HttpParams()
    .set('FormUploadID', FormUploadID.toString())
    .set('CategoryID', CategoryID.toString())
    .set('categoryName', categoryName.toString());  
    return this._http.get<any>('api/DigitalFormIdentity/DFIReportUpdateCategoryName', { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }

  public DFIReportUpdateSectionCategoryOrderUp(FormUploadID: number, Order:number): Observable<boolean> { 
    let params = new HttpParams()
    params.set('FormUploadID', FormUploadID.toString());
    params.set('Order', Order.toString()); 
    return this._http.get<any>('api/DigitalFormIdentity/DFIReportUpdateSectionCategoryOrderUp', { params }).pipe(
      share(),
      catchError(this.handleError)
    );
  }

  DFIReportUpdateSectionCategoryOrderDown(FormUploadID: number, Order: number): Observable<boolean> { 
    let params = new HttpParams()
      .set('FormUploadID', FormUploadID.toString())
      .set('Order', Order.toString()); 
      
    return this._http.get<boolean>('api/DigitalFormIdentity/DFIReportUpdateSectionCategoryOrderDown', { params })
      .pipe(
        share(),
        catchError(this.handleError)
      );
  }
   DFIRportAddRecordsNewInspection(FormuploadID: number): Observable<boolean> { 
    let params = new HttpParams().set('FormuploadID', FormuploadID.toString()); 
    return this._http.get<any>('api/DigitalFormIdentity/DFIRportAddRecordsNewInspection', { params }) .pipe(
      share(),
      catchError(this.handleError)
    );
  }
  //test code to get
  // public DFIRportAddRecordsNewInspection(FormuploadID: number): Observable<boolean[]> {
  //   let params = new HttpParams().set('formId', formId.toString());
    
  //   return this._http.get<FormHeaderVM[]>(this.GetFormHeaderInfo, { params }).pipe(
  //     share(),
  //     catchError(this.handleError)
  //   );
  // }
  //test code end

  private handleError(error: any) {
    console.error('An error occurred:', error);
    return throwError(error.message || error);
  }
  getInspectorsName(customerId: number, jobsiteId: number): Observable<InspectorDto> {
    const params = new HttpParams()
      .set('CustomerId', customerId.toString())
      .set('JobsiteId', jobsiteId.toString());
    return this._http.get<InspectorDto>('api/DigitalFormIdentity/GetInspectorsName', { params }).pipe(share(),catchError(this.handleError));
  }
}
